import React, {Component} from 'react'
import CacheManager from "../../cache/CacheManager";
import CacheKeys from "../../cache/CacheKeys";
import {withRouter} from "react-router-dom";
import LeegalityAccountMappingListPageUI from "./LeegalityAccountMappingListPageUI";

class LeegalityAccountMappingListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      accountList: null,
      messageList: null,

      leegalityDocList: null,
    }
  }

  render() {
    return (
      <LeegalityAccountMappingListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        accountList={this.state.accountList}
        messageList={this.state.messageList}

        leegalityDocList={this.state.leegalityDocList}

      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
    this.getLoans(context)
  }

  getLoans(context) {
    this.setState({leegalityDocList: []})
  }

  // getLoans(context) {
  //   RestApiUtils.get(
  //     this.props.context,
  //     `/api/loans/${this.props.match.params.accountId}`,
  //     this.getLoansCallback
  //   )
  // }
  //
  // getLoansCallback = (response) => {
  //   this.setState({errorList: response.errorList, loanList: response.loans})
  // }

  getMessages(context) {
    let arr = [
      'c_loans',
      'c_no_leegality_mappings_msg',
      'c_unknown_error',
      'c_leegality_mappings',
      'c_refresh',
      'c_no_loans_msg',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('LeegalityAccountMappingListPageSF', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList: response.messageList})
  }
}

export default withRouter(LeegalityAccountMappingListPageSF)
